import styled from 'styled-components'

const InfoContainer = styled.div`
  
`

export {
  InfoContainer
}